'use strict';
import {reactReduxModal as chatChannelModal} from '../redux/chatChannelModal';
import {reduxList as chatMessageList} from '../redux/chatMessageList';
import {reduxList as chatSubscriberList} from '../redux/chatSubscriberList';
import {reduxList as userSubscriptions} from '../redux/userSubscriptions';
import {videoChatStartModal} from '../redux/videoChatStartModal';
import {videoSessionRequests} from '../redux/videoSessionRequests';
import {epics as onMarkCommentsReadEpics} from './onMarkCommentsRead';


export const epics = [
  ...chatMessageList.epics.epics,
  ...chatChannelModal.epics.epics,
  ...chatSubscriberList.epics.epics,
  ...userSubscriptions.epics.epics,
  ...videoChatStartModal.epics.epics,
  ...videoSessionRequests.epics.epics,
  ...onMarkCommentsReadEpics,
];



// WEBPACK FOOTER //
// ./src/js/comments/epics/index.js